import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/i9PUCK4ciWvjiydbHtcGr6/Isologo_azul.png';
export function Hero() {
  return <section id="top" className="relative flex min-h-screen w-full overflow-hidden bg-[#071C3D]" data-id="element-102" data-mp="9ll8gva8vumg">
      <div className="absolute inset-0" aria-hidden="true" data-id="element-103" data-mp="4n1kyqg06arz">
        <img src={HERO_IMG} alt="" className="h-full w-full object-cover opacity-90" data-id="element-104" data-mp="1297a3xzwwp6o" />
        <div className="absolute inset-0 bg-[#071C3D]/55" data-id="element-105" data-mp="xae8b2tzmmmc" />
      </div>

      <div className="relative z-10 flex w-full flex-col justify-between gap-12 px-6 pb-8 pt-36 lg:px-10 lg:pb-10 lg:pt-32" data-id="element-106" data-mp="xb5rfe6eervq">
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.75,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mx-auto flex w-full max-w-7xl flex-1 flex-col items-center justify-between gap-12 text-center sm:gap-16" data-id="element-107" data-mp="nc894szkful6">
          <p className="text-xs font-medium uppercase tracking-[0.25em] text-vm-muted" data-id="element-108" data-mp="3j7zf9iqmlsgo">
            Tecnología visual en movimiento
          </p>

          <h1 className="mx-auto max-w-full font-bornia text-[clamp(37px,10.5vw,48px)] font-extrabold uppercase leading-[1.3] tracking-[-0.02em] text-white lg:text-[clamp(68px,6vw,96px)] lg:leading-[1.24]" data-id="element-109" data-mp="3o73qeex4209n">
            <span className="block" data-id="element-110" data-mp="3e7l802wummjp">Creamos historias</span>
            <span className="block text-[clamp(34px,9.5vw,44px)] tracking-[-0.01em] lg:text-[clamp(62px,5.5vw,88px)]" data-id="element-111" data-mp="30hrjxmt646b1">que conectan</span>
            <span className="block text-[clamp(34px,9.5vw,44px)] tracking-[-0.01em] text-vm-cream lg:text-[clamp(62px,5.5vw,88px)]" data-id="element-112" data-mp="35a2h4hwixdzw">marcas <span className="text-white" data-id="element-113" data-mp="2viy25i6ult52">con</span></span>
            <span className="block text-[clamp(34px,9.5vw,44px)] tracking-[-0.01em] text-vm-cream lg:text-[clamp(62px,5.5vw,88px)]" data-id="element-114" data-mp="2vjg670zr5bnj">personas</span>
          </h1>

          <a href="#contacto" className="inline-flex items-center gap-3 rounded-2xl bg-vm-sky px-7 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-vm-bg shadow-lg shadow-black/20 transition-all duration-200 hover:-translate-y-0.5 hover:bg-vm-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-vm-sky focus-visible:ring-offset-4 focus-visible:ring-offset-vm-bg" data-id="element-115" data-mp="2lla4ajdy45io">
            <FileTextIcon className="h-5 w-5" aria-hidden="true" data-id="element-116" data-mp="de6rj0zawjpj" />
            Conversemos tu proyecto
          </a>
        </motion.div>

        <div className="mx-auto mt-10 flex w-full max-w-7xl items-center justify-between border-t border-white/20 pt-5 text-[10px] font-medium uppercase tracking-[0.25em] text-vm-muted sm:text-xs" data-id="element-117" data-mp="1ayt6mzo5djaw">
          <span data-id="element-118" data-mp="114svag29vhtq">Vivo Media</span>
          <span data-id="element-119" data-mp="x1nv4k5nzs89">Desde Uruguay</span>
        </div>
      </div>
    </section>;
}